/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import 'vuetify/styles'
import * as components from 'vuetify/components'
// Composables
import * as directives from 'vuetify/directives'
import { de, en, fr, it } from 'vuetify/locale'
import { config, themes } from '@deepcloud/deep-ui-lib'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default config.createVuetifyConfig({
  directives,
  components,
  locale: {
    messages: {
      de,
      en,
      fr,
      it,
    },
    locale: import.meta.env.VITE_I18N_LOCALE,
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        ...themes.deepCloudLight,
        colors: {
          ...themes.deepBoxLight.colors,
          ...themes.deepNinjaLight.colors,
          ...themes.hoopLight.colors,
          ...themes.deepSignLight.colors,
          ...themes.deepVLight.colors,
          ...themes.deepCloudLight.colors,
        },
        variables: {
          'disabled-opacity': 0.7,
        },
      },
      dark: {
        ...themes.deepCloudDark,
        colors: {
          ...themes.deepBoxDark.colors,
          ...themes.deepNinjaDark.colors,
          ...themes.hoopDark.colors,
          ...themes.deepSignDark.colors,
          ...themes.deepVDark.colors,
          ...themes.deepCloudDark.colors,
        },
        variables: {
          'disabled-opacity': 0.7,
        },
      },
    },
  },
  aliases: {},
  defaults: {
    // Aliases
    VBtnSecondary: {
      variant: 'outlined',
      color: 'primary',
    },

    // Vuetify
    VIcon: {
      size: 18,
    },
    VMenu: {
      VCard: {
        rounded: 'lg',
      },
      VList: {
        rounded: 'lg',
      },
    },
    VCard: {
      rounded: 'lg',
    },
    VAvatar: {
      // https://github.com/vuetifyjs/vuetify/issues/20345
      border: 0,
    },
    VTextField: {
      variant: 'outlined',
      color: 'primary',
    },
    VTextarea: {
      variant: 'outlined',
      color: 'primary',
    },
    VSelect: {
      variant: 'outlined',
      color: 'primary',
      itemColor: 'primary',
    },
    VAutocomplete: {
      variant: 'outlined',
      color: 'primary',
      itemColor: 'primary',
      menuProps: {
        contentClass: 'rounded-lg',
      },
    },
    VNumberInput: {
      variant: 'outlined',
      color: 'primary',
    },
    VCombobox: {
      color: 'primary',
      itemColor: 'primary',
      menuProps: {
        contentClass: 'rounded-lg',
      },
    },
    VStepperItem: {
      editIcon: 'far fa-pencil',
    },
    VDataTableServer: {
      VSelectionControl: {
        color: 'primary',
      },
    },
    VCheckbox: {
      color: 'primary',
    },
  },
})
